import { getAPIUrl } from '../../../../api/apiUtils';
import AxiosClient, { getLogOptions } from './axios.service';

export const getFormTemplates = ({ accountId, authenticityToken }) => {
  const baseUrl = getAPIUrl(accountId);

  return AxiosClient.get({
    options: getLogOptions(authenticityToken, getFormTemplates.name),
    url: `${baseUrl}/administration/form_templates`,
  });
};

export default getFormTemplates;
